(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["help-center-contact"] && !Shopify.designMode) return;
  try {
    
function showHelpCenterContactSuccess() {
    if (new URLSearchParams(window.location.search).get('contact_posted') !== 'true') return;
    const message = document.querySelector('.help-center-contact .success-message');
    if (message) {
        message.style.display = 'block';
        message.scrollIntoView({ behavior: 'smooth' });
    }
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showHelpCenterContactSuccess);
} else {
    showHelpCenterContactSuccess();
}
document.addEventListener('shopify:section:load', showHelpCenterContactSuccess);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-center-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:block:select', function(event) {
    if (!event.target.closest('.help-center-faq')) return;
    const tab = event.target.querySelector('collapsible-tab');
    if (tab && typeof tab.open === 'function' && !tab.selected) tab.open();
});

  } catch(e) { console.error(e); }
})();
})();
